import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import {
  Modal, ModalHeader, ModalBody, ModalFooter, Button,
  // Pagination, ProgressCircle
} from '@americanexpress/dls-react';
// MT: PDF preview is disabled pending double-byte fix
// import { Document, Page } from 'react-pdf';
import { compose } from 'redux';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { connect } from 'react-redux';
import { IntlProvider, FormattedMessage } from 'react-intl';

class DocPreview extends Component {
  constructor(props) {
    super(props);
    this.loadFile = this.loadFile.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  /* eslint-disable react/no-unused-state -- PDF preview vars */
  /* eslint-disable react/state-in-constructor -- class property */
  state = {
    fileType: '',
    imgUrl: null,
    numPages: 0,
    pageNumber: 1,
    windowHeight: 0,
    windowWidth: 0,
    showModal: false,
    isMobileScreen: false,
  };
  /* eslint-enable react/no-unused-state */
  /* eslint-enable react/state-in-constructor */

  componentDidMount() {
    const {
      documentId,
      fileId,
      previewMode,
      fileName,
    } = this.props;
    if (!previewMode && fileId !== null && documentId !== null) {
      this.loadFile();
    }

    const extensionRegex = /(?:\.([^.]+))?$/;
    const extension = extensionRegex.exec(fileName)[1];
    if (extension !== undefined) this.setState({ fileType: extension.toUpperCase() });

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  loadFile = () => {
    const {
      docUploadUrl,
      documentId,
      fileId,
      processId,
      consumerId,
      fileSize,
      downloadProgress,
    } = this.props;
    const requestBody = {
      processId,
      consumerId,
    };
    let downloadProg = 1;
    if (downloadProgress) {
      downloadProgress({ fileId, downloadProg });
    }

    const xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    xhr.open('POST', `${docUploadUrl}/servicing/v1/communications/docs/${documentId}/file/${fileId}`);
    // xhr.responseType = 'arraybuffer';
    xhr.responseType = 'blob';
    xhr.setRequestHeader('icaas-correlation-id', 'preview-test');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(requestBody));
    xhr.addEventListener('progress', (event) => {
      downloadProg = Number((event.loaded / fileSize) * 100).toFixed(0);
      if (downloadProgress) {
        downloadProgress({ fileId, downloadProg });
      }
    });
    xhr.addEventListener('load', async (event) => {
      const {
        fileType,
      } = this.state;

      const blob = new Blob([event.target.response], { type: event.target.response.type });
      const url = window.URL.createObjectURL(blob);
      this.setState({ imgUrl: url });
      // MT: Disable PDF preview, pending font fix for double-byte characters
      // if (['GIF', 'JPEG', 'JPG', 'BMP', 'PNG', 'PDF'].includes(fileType)) {
      if (['GIF', 'JPEG', 'JPG', 'BMP', 'PNG'].includes(fileType)) {
        this.setState({ showModal: true });
      } else {
        this.downloadFile();
      }
    });
    xhr.addEventListener('error', () => {
      // bad response
    });
  };

  downloadFile = () => {
    const {
      fileName,
    } = this.props;

    const {
      imgUrl,
    } = this.state;

    const link = document.createElement('a');
    link.href = imgUrl;
    link.setAttribute('download', fileName);
    document.body.append(link);
    link.click();
    link.remove();
  };

  closeModal = () => {
    this.setState({ showModal: false, imgUrl: null });
    setTimeout(() => {
      const { fileId } = this.props;
      const trigerElement = document.querySelector(`#previewButton-${fileId}`);
      if (trigerElement) {
        trigerElement.focus();
      }
    }, 500);
  };

  // sets the total page number of pdfs uploaded
  // eslint-disable-next-line react/no-unused-class-component-methods -- used when PDF preview is enabled
  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  };

  // eslint-disable-next-line react/no-unused-class-component-methods -- used when PDF preview is enabled
  previousPage = () => {
    const { pageNumber } = this.state;
    if (pageNumber === 1) return;
    this.setState({ pageNumber: pageNumber - 1 });
  };

  // eslint-disable-next-line react/no-unused-class-component-methods -- used when PDF preview is enabled
  nextPage = () => {
    const { pageNumber, numPages } = this.state;
    if (pageNumber === numPages) return;
    this.setState({ pageNumber: pageNumber + 1 });
  };

  // eslint-disable-next-line react/no-unused-class-component-methods -- used when PDF preview is enabled
  setPage = (pageNumber) => {
    this.setState({ pageNumber });
  };

  updateWindowDimensions() {
    if (window.innerWidth < 1.5 * window.innerHeight) {
      this.setState({ isMobileScreen: true });
    } else {
      this.setState({ isMobileScreen: false });
    }
    // eslint-disable-next-line react/no-unused-state -- windowWidth used when PDF preview is enabled
    this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
  }

  render() {
    const {
      fileName,
      locale,
      languageData,
    } = this.props;

    const {
      imgUrl,
      windowHeight,
      fileType,
      showModal,
      isMobileScreen,
      // MT: This state is used for PDF preview, currently disabled
      // pageNumber,
      // numPages,
      // windowWidth,
    } = this.state;

    return (
      <IntlProvider locale={locale} messages={languageData}>
        <div>
          {showModal && (
            <Modal
              id="document-preview-modal"
              onClose={this.closeModal}
              aria-labelledby="document-preview-modal-title"
            >
              <ModalHeader>
                <h2 id="document-preview-modal-title" className="fluid heading-3">{fileName}</h2>
              </ModalHeader>
              <ModalBody>
                <div style={{ display: isMobileScreen && fileType === 'PDF' ? 'inline' : 'flex', justifyContent: 'center' }}>
                  {/* MT: Disable PDF preview, pending font fix for double-byte characters */}
                  {
                  // (fileType === 'PDF' && (
                  //   <Document
                  //     file={imgUrl}
                  //     onLoadSuccess={this.onDocumentLoadSuccess}
                  //     loading={<ProgressCircle style={{ paddingTop: '3%' }} />}
                  //   >
                  //     {/* responsive for mobile */}
                  //     {isMobileScreen ? (
                  //       <Page
                  //         pageNumber={pageNumber}
                  //         width={windowWidth * 0.85}
                  //         renderAnnotationLayer={false}
                  //       />
                  //     )
                  //       : (
                  //         <Page
                  //           pageNumber={pageNumber}
                  //           height={windowHeight * 0.7}
                  //           renderAnnotationLayer={false}
                  //         />
                  //       )}

                  //     {
                  //       numPages > 1 ? (
                  //         <div className="flex" style={{ justifyContent: 'center' }}>
                  //           <Pagination
                  //             id="pagination"
                  //             selected={pageNumber}
                  //             previousText={languageData.Previous}
                  //             nextText={languageData.Next}
                  //             onChange={this.setPage}
                  //             total={numPages}
                  //           />
                  //         </div>
                  //       ) : ''
                  //     }

                  //   </Document>
                  // ))
                  // ||
                  (['GIF', 'JPEG', 'JPG', 'BMP', 'PNG'].includes(fileType) && (
                    <img src={imgUrl} alt="preview" style={{ maxHeight: `${windowHeight * 0.7}px` }} />))
                  }
                </div>
              </ModalBody>
              <ModalFooter>
                <Button styleType="primary" onClick={this.downloadFile}>
                  <FormattedMessage id="download" />
                </Button>
              </ModalFooter>
            </Modal>
          )}
        </div>
      </IntlProvider>
    );
  }
}

DocPreview.defaultProps = {
  previewMode: false,
  downloadProgress: null,
  locale: 'en-US',
  languageData: {},
};

DocPreview.propTypes = {
  docUploadUrl: PropTypes.string.isRequired,
  documentId: PropTypes.string.isRequired,
  fileId: PropTypes.string.isRequired,
  processId: PropTypes.string.isRequired,
  consumerId: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  fileSize: PropTypes.string.isRequired,
  downloadProgress: PropTypes.func,
  // eslint-disable-next-line react/boolean-prop-naming -- existing API, renaming would be a breaking change
  previewMode: PropTypes.bool,
  locale: PropTypes.string,
  languageData: PropTypes.instanceOf(Object),
};

export function mapStateToProps(state) {
  const docUploadUrl = state.getIn(['config', 'imageViewerDocUploadApiUrl']);
  return {
    docUploadUrl,
  };
}

export const loadModuleData = async ({ store: { dispatch } }) => {
  await dispatch(loadLanguagePack('axp-doc-upload-preview', { fallbackLocale: 'en-US' }));
};

DocPreview.holocron = {
  name: 'axp-doc-upload-preview',
  loadModuleData,
};

const UnwrappedDocPreview = DocPreview;
export { UnwrappedDocPreview };

export default compose(
  oneAppModuleWrapper('axp-doc-upload-preview'),
  connect(mapStateToProps)
)(DocPreview);
